import styled, { css } from 'styled-components';
export var StyledTabs = styled.div.withConfig({
  displayName: "StyledTabs",
  componentId: "sc-10rp31r-0"
})(["align-items:center;display:flex;"]);
var activeTab = css(["color:#333333;font-weight:700;line-height:20px;a{color:#333333 !important;}&::after{background:#6a58dc;}"]);
export var StyledTab = styled.div.withConfig({
  displayName: "StyledTab",
  componentId: "sc-10rp31r-1"
})(["color:#6f7390;cursor:pointer;font-size:15px;font-weight:400;line-height:20px;position:relative;a{color:#6f7390 !important;}&::after{content:'';background:transparent;border-radius:19px;bottom:-5px;display:block;height:2px;left:calc(50% - 10px);position:absolute;width:20px;}", ""], _ref => {
  var active = _ref.active;
  return active ? activeTab : null;
});
export var StyledPipe = styled.div.withConfig({
  displayName: "StyledPipe",
  componentId: "sc-10rp31r-2"
})(["background:#ebebeb;height:12px;margin:0 20px;opacity:0.7;width:1px;"]);